<template>
  <div class="org-item">
    <div
      class="org-box"
      :class="{ 'org-box-sobre': arrastandoSobre, 'org-box-cnpj': no.tipo === 'cnpj', 'org-box-beneficiario': no.tipo === 'beneficiario' }"
      data-org-box
      :data-entidade-id="no.id"
      :data-pai-id="paiId"
      :data-percentual="no.tipo === 'beneficiario' ? no.percentualEdge : ''"
      :draggable="no.tipo === 'entidade'"
      @dragstart="onDragStart"
      @dragover.prevent="onDragOver"
      @dragleave="arrastandoSobre = false"
      @drop="onDrop"
      @click="onClick"
      @touchstart="onTouchStart"
      @touchmove="onTouchMove"
      @touchend="onTouchEnd"
    >
      <div class="org-nome">{{ no.nome }}</div>
      <div v-if="no.tipoEntidade" class="org-tipo">{{ no.tipoEntidade }}</div>
    </div>
    <div v-if="no.filhos && no.filhos.length" class="org-filhos">
      <MasterOrganogramaNo
        v-for="filho in no.filhos"
        :key="filho.id"
        :no="filho"
        :pai-id="no.id"
        @soltar="$emit('soltar', $event)"
        @abrir-acoes="$emit('abrir-acoes', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MasterOrganogramaNo',
  props: {
    no: { type: Object, required: true },
    paiId: { type: [Number, String], default: null }
  },
  emits: ['soltar', 'abrir-acoes'],
  data() {
    return { arrastandoSobre: false }
  },
  methods: {
    onDragStart(e) {
      if (this.no.tipo !== 'entidade') { e.preventDefault(); return }
      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.setData('text/plain', JSON.stringify({ entidadeId: this.no.id, relacionamentoId: this.no.relacionamentoId }))
      e.stopPropagation()
    },
    onDragOver() {
      if (this.no.tipo === 'entidade') this.arrastandoSobre = true
    },
    onDrop(e) {
      if (this.no.tipo !== 'entidade') return
      e.preventDefault()
      e.stopPropagation()
      this.arrastandoSobre = false
      let dados = null
      try { dados = JSON.parse(e.dataTransfer.getData('text/plain')) } catch (err) { return }
      if (!dados || dados.entidadeId === this.no.id) return
      this.$emit('soltar', { entidadeOrigemId: dados.entidadeId, relacionamentoOrigemId: dados.relacionamentoId, novoSuperiorId: this.no.id })
    },
    onClick(e) {
      if (this.no.tipo !== 'entidade') return
      e.stopPropagation()
      this.$emit('abrir-acoes', this.no)
    },
    onTouchStart(e) {
      if (this.no.tipo !== 'entidade') return
      const t = e.touches[0]
      this._toqueX = t.clientX
      this._toqueY = t.clientY
      this._toqueMoveu = false
      this._arrastandoToque = false
    },
    onTouchMove(e) {
      if (this.no.tipo !== 'entidade') return
      const t = e.touches[0]
      if (!this._toqueMoveu) {
        const dx = Math.abs(t.clientX - this._toqueX)
        const dy = Math.abs(t.clientY - this._toqueY)
        if (dx > 10 || dy > 10) { this._toqueMoveu = true; this._arrastandoToque = true }
      }
      if (this._arrastandoToque) {
        e.preventDefault()
        document.querySelectorAll('.org-box-sobre-toque').forEach(n => n.classList.remove('org-box-sobre-toque'))
        const el = document.elementFromPoint(t.clientX, t.clientY)
        const alvo = el ? el.closest('[data-org-box]') : null
        if (alvo && alvo.getAttribute('data-entidade-id') !== String(this.no.id)) {
          alvo.classList.add('org-box-sobre-toque')
        }
      }
    },
    onTouchEnd(e) {
      if (this.no.tipo !== 'entidade') return
      document.querySelectorAll('.org-box-sobre-toque').forEach(n => n.classList.remove('org-box-sobre-toque'))
      if (this._arrastandoToque) {
        const t = e.changedTouches[0]
        const el = document.elementFromPoint(t.clientX, t.clientY)
        const alvo = el ? el.closest('[data-org-box]') : null
        const alvoId = alvo ? alvo.getAttribute('data-entidade-id') : null
        if (alvoId && alvoId !== String(this.no.id)) {
          const novoSuperiorId = alvoId === 'master-root' ? null : Number(alvoId)
          this.$emit('soltar', { entidadeOrigemId: this.no.id, relacionamentoOrigemId: this.no.relacionamentoId, novoSuperiorId })
        }
      } else if (!this._toqueMoveu) {
        this.$emit('abrir-acoes', this.no)
      }
      this._arrastandoToque = false
      this._toqueMoveu = false
    }
  }
}
</script>

<style scoped>
.org-item { display: flex; flex-direction: column; align-items: center; }
.org-box {
  background: #fff;
  border: 1px solid #dfe3d6;
  border-radius: 6px;
  padding: 10px 14px;
  min-width: 140px;
  cursor: grab;
  transition: box-shadow .15s, border-color .15s;
  touch-action: none;
}
.org-box:hover { box-shadow: 0 2px 6px rgba(0,0,0,.08); }
.org-box-sobre, .org-box-sobre-toque { border-color: #4a5c2f; box-shadow: 0 0 0 2px rgba(74,92,47,.25); }
.org-box-cnpj { background: #eef2e6; border-color: #c7d4bb; cursor: default; }
.org-box-beneficiario { background: #fbfaf5; border: 1px dashed #d7ceb0; min-width: 120px; padding: 7px 12px; cursor: default; }
.org-nome { font-size: 13px; font-weight: 700; color: #28331a; }
.org-box-beneficiario .org-nome { font-size: 12px; font-weight: 600; }
.org-tipo { font-size: 9px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; color: #6b7a57; margin-top: 2px; }
.org-filhos { display: flex; gap: 24px; padding-top: 34px; }
</style>
